import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

let wasRestoredFromBfcache = false;

// Disable the browser's automatic scroll restoration once, at module load.
// Browsers (notably iOS Safari) race React effects when this is left on
// 'auto', and on SPA pushState navigations they re-apply the previous
// route's scroll Y after the new document grows — landing the user mid- or
// bottom-of-page. We take over restoration explicitly.
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

if (typeof window !== 'undefined') {
  window.addEventListener('pageshow', (event) => {
    wasRestoredFromBfcache = event.persisted === true;
  });
}

/**
 * Resets window scroll to (0, 0) on every pathname change.
 *
 * Uses useLayoutEffect so the reset happens synchronously before the
 * browser paints the new route — no flash of the previous scroll position.
 * Mount this once inside the Router, above <Routes>.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    if (wasRestoredFromBfcache) {
      wasRestoredFromBfcache = false;
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
